(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["se-product-assistance"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('se-product-assistance')) customElements.define('se-product-assistance', class extends HTMLElement {
 connectedCallback(){
   this.updateLink=this.updateLink.bind(this);
   this.scheduleUpdate=()=>requestAnimationFrame(this.updateLink);
   this.container=this.closest('product-info')||this.closest('.product__info-container');
   this.addEventListener('pointerdown',this.updateLink);
   this.addEventListener('focusin',this.updateLink);
   this.container?.addEventListener('change',this.scheduleUpdate);
   this.container?.addEventListener('input',this.scheduleUpdate);
   this.container?.addEventListener('click',this.scheduleUpdate);
   this.updateLink();
 }
 disconnectedCallback(){
   this.container?.removeEventListener('change',this.scheduleUpdate);
   this.container?.removeEventListener('input',this.scheduleUpdate);
   this.container?.removeEventListener('click',this.scheduleUpdate);
 }
 updateLink(){const container=this.container||this.closest('product-info')||this.closest('.product__info-container');if(!container)return;const choices=[...new Set([...container.querySelectorAll('variant-selects input:checked, variant-selects select')].map(el=>el.value).filter(Boolean))];const quantity=container.querySelector('input[name="quantity"]')?.value||'1';const message=[this.dataset.intro,this.dataset.title,...choices,`${this.dataset.quantity}: ${quantity}`,this.dataset.url].join(String.fromCharCode(10));this.querySelector('a').href=`https://wa.me/27684578603?text=${encodeURIComponent(message)}`;}
});
  } catch(e) { console.error(e); }
})();

})();
